export const analyzeImageWithGroq = async (imageBase64) => {
  try {
    const apiKey = process.env.REACT_APP_GROQ_API_KEY || "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"
    
    const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        model: "meta-llama/llama-4-scout-17b-16e-instruct",
        messages: [
          {
            role: "user",
            content: [
              {
                type: "text",
                text: "Analyze this full body image and extract precise body measurements for clothing sizing. Extract bust, waist, hips, inseam, and shoulder measurements in inches. You must return ONLY a valid JSON object with the measurements. If measurements cannot be extracted, still return a JSON with estimated average measurements and include a field 'isEstimate: true'."
              },
              {
                type: "image_url",
                image_url: { url: `data:image/jpeg;base64,${imageBase64}` }
              }
            ]
          }
        ],
        response_format: { type: "json_object" },
        max_tokens: 1024
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(`API error: ${errorData.error?.message || response.statusText}`);
    }
    
    const data = await response.json();
    console.log("Raw Groq API response:", data);
    
    // Get the content from the response
    const content = data.choices[0].message.content;
    console.log("Content from Groq:", content);
    
    // Try to parse the JSON content
    let parsedContent;
    try {
      parsedContent = JSON.parse(content);
    } catch (e) {
      console.error("Failed to parse JSON from Groq response", e);
      
      // Extract any numbers that might be in the response
      const numbersInResponse = extractMeasurementsFromText(content);
      if (Object.keys(numbersInResponse).length > 0) {
        parsedContent = numbersInResponse;
      } else {
        // If we can't extract numbers, use mock data
        console.log('Unable to extract measurements from text response, using mock data');
        return getMockMeasurements(true);
      }
    }
    
    // Format to match what your app expects
    // Convert keys to lowercase and ensure all required fields are present
    const formattedMeasurements = {
      bust: parsedContent.Bust || parsedContent.bust || 0,
      waist: parsedContent.Waist || parsedContent.waist || 0,
      hips: parsedContent.Hips || parsedContent.hips || 0,
      inseam: parsedContent.Inseam || parsedContent.inseam || 0,
      shoulders: parsedContent.Shoulder || parsedContent.shoulder || 
               parsedContent.Shoulders || parsedContent.shoulders || 0,
      isEstimate: parsedContent.isEstimate || false
    };
    
    console.log("Formatted measurements:", formattedMeasurements);
    return formattedMeasurements;
  } catch (error) {
    console.error('Error calling Groq API:', error);
    
    // If there's an error, return mock measurements
    console.log('Falling back to mock measurements');
    return getMockMeasurements(true);
  }
};

// Function to extract measurements from text response
const extractMeasurementsFromText = (text) => {
  const measurements = {};
  
  // Look for patterns like "Bust: 36 inches" or "Bust: 36"
  const bustMatch = text.match(/bust\D+(\d+\.?\d*)/i);
  if (bustMatch) measurements.bust = parseFloat(bustMatch[1]);
  
  const waistMatch = text.match(/waist\D+(\d+\.?\d*)/i);
  if (waistMatch) measurements.waist = parseFloat(waistMatch[1]);
  
  const hipsMatch = text.match(/hips\D+(\d+\.?\d*)/i);
  if (hipsMatch) measurements.hips = parseFloat(hipsMatch[1]);
  
  const inseamMatch = text.match(/inseam\D+(\d+\.?\d*)/i);
  if (inseamMatch) measurements.inseam = parseFloat(inseamMatch[1]);
  
  const shoulderMatch = text.match(/shoulder\D+(\d+\.?\d*)/i);
  if (shoulderMatch) measurements.shoulders = parseFloat(shoulderMatch[1]);
  
  // Add isEstimate flag if we extracted from text
  if (Object.keys(measurements).length > 0) {
    measurements.isEstimate = true;
  }
  
  return measurements;
};

// Update mock measurements to match the expected format
export const getMockMeasurements = (isEstimate = false) => {
  return {
    bust: 36.5,
    waist: 28.2,
    hips: 38.7,
    inseam: 30.5,
    shoulders: 16.1,
    isEstimate: isEstimate
  };
};
